import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureAttribution } from '../../utils/attribution';

export default function AttributionCapture() {
  const { search, pathname } = useLocation();
  useEffect(() => {
    captureAttribution(search, pathname);
    // Solo la primera carga: el resto de navegaciones no cambian de dónde vino.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
